export default __webpack_public_path__ + "569e1950e7e307a77bbaf9d17bcbb37f.png";